import { autoinject } from 'aurelia-framework';

@autoinject
export class MathService {
  public round(number: number, decimals: number) {
    return +(Math.round(number + ("e+" + decimals) as any) + "e-" + decimals);
  }
}
